// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerText {
    margin-bottom: 25px;
}

.searchAndButtonContainer{
    display: flex;
    justify-content: center;
    align-items: center;
}

.searchAndButtonContainer > .searchContainer {
    width: 50%;
    display: flex;
    justify-content: center;
    height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/components/admin-config/userRegister/UserRegister.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB","sourcesContent":[".headerText {\n    margin-bottom: 25px;\n}\n\n.searchAndButtonContainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.searchAndButtonContainer > .searchContainer {\n    width: 50%;\n    display: flex;\n    justify-content: center;\n    height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
